import { render } from "./TruckItem.vue?vue&type=template&id=b5e9a5ee&scoped=true"
import script from "./TruckItem.vue?vue&type=script&lang=js"
export * from "./TruckItem.vue?vue&type=script&lang=js"

import "./TruckItem.vue?vue&type=style&index=0&id=b5e9a5ee&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e9a5ee"]])

export default __exports__